export default __webpack_public_path__ + "static/media/bs-secondary-convertible.d0407d12.svg";